import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SeoHead({
  title = 'ibjerget.dk – Et spirituelt fællesskab',
  description = 'Ibjerget på Midtfyn er et spirituelt behandlerfællesskab med kropsterapi, ALT ansigtsterapi, massage, tarotkortterapi, foredrag samt spirituelle bøger og kunst.',
  image = 'https://assets.auxodev.dk/assets/1df9f3fb-cd3d-49d9-8f1a-8a59416f1b4e/ibjerget-hero-nature.jpg',
  canonicalUrl,
  type = 'website'
}) {
  const fullTitle = title.includes('Ibjerget') || title.includes('ibjerget.dk') 
    ? title 
    : `${title} – Ibjerget`;

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Golden Eagle Terapier på Midtfyn, herunder Forlaget Golden Eagle',
    legalName: 'Golden Eagle Terapier på Midtfyn, herunder Forlaget Golden Eagle',
    description: description,
    image: image,
    telephone: '+4566157902',
    email: 'lone.hvid@hotmail.com',
    taxID: '42494445',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Ibjergvej 12',
      addressLocality: 'Årslev',
      postalCode: '5792',
      addressCountry: 'DK'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 55.3021,
      longitude: 10.4632
    },
    url: 'https://www.ibjerget.dk/'
  };

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <html lang="da-DK" />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content="da_DK" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

      {/* Structured Data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}
